import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import Loader from 'Component/Loader';
import ProductCard from 'Component/ProductCard';
import { GRID_LAYOUT } from 'Route/CategoryPage/CategoryPage.config';
import {
    ProductListPage as SourceProductListPage
} from 'SourceComponent/ProductListPage/ProductListPage.component';
import { isMobile } from 'Util/Mobile';

import './ProductListPage.override.style';

/** @namespace Elganso/Component/ProductListPage/Component */
export class ProductListPage extends SourceProductListPage {
    static propTypes = {
        ...this.propTypes,
        isPlp: PropTypes.bool,
        pageSize: PropTypes.number,
        loadPlaceholder: PropTypes.bool
    };

    static defaultProps = {
        ...this.defaultProps,
        isPlp: false
    };

    componentDidUpdate() {
        super.componentDidUpdate();

        // Previene error en IOS 16 al cambiar los articulos por fila
        const elements = document.querySelectorAll('.CategoryProductList-Page');
        for (let i = 0; i < elements.length; i++) {
            if (elements[i] !== undefined && elements[i].style !== undefined) {
                elements[i].style.opacity = 0.95;
                setTimeout(() => {
                    elements[i].style.opacity = 1;
                }, 50);
            }
        }
    }

    renderPlaceholders() {
        const {
            numberOfPlaceholders,
            pageSize,
            mix: {
                mods: {
                    layout = GRID_LAYOUT
                } = {}
            }
        } = this.props;

        // Actualizamos el numero de placeholders segun longitud de pagina
        const nPlaceholders = numberOfPlaceholders !== pageSize ? pageSize : numberOfPlaceholders;

        return Array.from(
            { length: nPlaceholders },
            (_, i) => (
                <ProductCard
                  key={ i }
                  product={ {} }
                  layout={ layout }
                />
            )
        );
    }

    renderItems() {
        const { items, isLoading, loadPlaceholder } = this.props;

        if (!items.length || isLoading) {
            if (loadPlaceholder) {
                return this.renderPlaceholderItems();
            }

            return (
                <div
                  style={ {
                      display: 'block',
                      width: '100%',
                      float: 'left'
                  } }
                >
                    { /* eslint-disable-next-line react/jsx-boolean-value */ }
                    <Loader isLoading={ true } />
                </div>
            );
        }

        return this.renderPageItems();
    }

    render() {
        const {
            pageNumber,
            wrapperRef,
            mix,
            valueColumn
        } = this.props;

        let columns = parseInt(valueColumn, 10);
        let activeClass = '8elem';

        if (!valueColumn || valueColumn <= 0) {
            const cookies = window.sessionStorage.getItem('display_mode');
            if (cookies) {
                columns = parseInt(cookies, 10);
            } else {
                if (isMobile.any()) {
                    columns = 2;
                    activeClass = 'elem2';
                } else {
                    columns = 4;
                    activeClass = 'elem4';
                }

                window.sessionStorage.setItem('display_mode', columns);
            }
        }

        if (columns === 1) {
            activeClass = 'elem1';
        } else if (columns === 2) {
            activeClass = 'elem2';
        } else if (columns === 3) {
            activeClass = 'elem3';
        } else if (columns === 4) {
            activeClass = 'elem4';
        } else if (columns === 5) {
            activeClass = 'elem5';
        } else if (columns === 6) {
            activeClass = 'elem6';
        } else if (columns === 7) {
            activeClass = 'elem7';
        } else if (columns === 8) {
            activeClass = 'elem8';
        }

        return (
            <ul
              block="ProductListPage"
              mix={ { ...mix, elem: 'Page' } }
              key={ pageNumber }
              ref={ wrapperRef }
              data-testid="ProductListPage"
              className={ activeClass }
            >
                { this.renderItems() }
            </ul>
        );
    }
}

export default withRouter(ProductListPage);
